/** @format */

export type initSumFeeSessionDataType = {
  credit: number;
  cvs: number;
  bank: number;
  atobarai: number;
};

export const initSumFeeSessionData: initSumFeeSessionDataType = {
  credit: 0,
  cvs: 0,
  bank: 0,
  atobarai: 0,
};
